/* @jsx h */
import { defineComponent, h } from "vue";

type Props = {
  title: string;
  subtitle?: string;
};

/**
 * Full-width header bar for a subpage inside a PageComponent (Catalog, Inventory, Work Day).
 *
 * Slots:
 *   default — actions, right-aligned (wraps under the title on narrow screens).
 *   badges  — small pills next to the title (counts, "3 changed", …).
 */
export const SubpageHeader = defineComponent<Props>({
  name: "SubpageHeader",
  props: ["title", "subtitle"],
  setup(props, { slots }) {
    return () => (
      <div class="flex shrink-0 flex-wrap items-center justify-between gap-3 border-b border-base-300 bg-base-100 px-5 py-4">
        <div class="min-w-0">
          <div class="flex flex-wrap items-center gap-2">
            <h2 class="text-lg font-semibold text-accent">{props.title}</h2>
            {slots.badges?.()}
          </div>
          {props.subtitle && <p class="mt-1 text-xs text-base-content/50">{props.subtitle}</p>}
        </div>
        {slots.default && <div class="flex flex-wrap items-center gap-2">{slots.default()}</div>}
      </div>
    );
  },
});
